var map = {
	"./brian_lee.png": "3d7d",
	"./bruce_lindsey.png": "3954",
	"./changhua_wu.png": "6af4",
	"./hailong_xu.png": "da52",
	"./heng_liu.png": "5009",
	"./jianmin_meng.png": "ce21",
	"./joseph_simon.png": "6e3e",
	"./luke_leung.png": "8dbe",
	"./martin_bechthold.png": "212d",
	"./qing_ye.png": "b3b0",
	"./stephen_lau.png": "89c8",
	"./volker_hartkopf.png": "5fe7",
	"./wei_he.png": "3154",
	"./xiaodu_liu.png": "8012",
	"./yunsheng_su.png": "638b",
	"./zhen_yu.png": "feaa",
	"./zhonggui_zhao.png": "c456"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5273";